const noop = function () { };
const fakeLogger = {
    trace: noop,
    debug: noop,
    log: noop,
    warn: noop,
    info: noop,
    error: noop,
};
let exportedLogger = fakeLogger;
function consolePrintFn(type) {
    const func = self.console[type];
    if (func) {
        return func.bind(self.console, `[${type}] >`);
    }
    return noop;
}
function exportLoggerFunctions(debugConfig, ...functions) {
    functions.forEach(function (type) {
        exportedLogger[type] = debugConfig[type]
            ? debugConfig[type].bind(debugConfig)
            : consolePrintFn(type);
    });
}
export function enableLogs(debugConfig, id) {
    if ((self.console && debugConfig === true) ||
        typeof debugConfig === 'object') {
        exportLoggerFunctions(debugConfig, 'debug', 'log', 'info', 'warn', 'error');
        try {
            exportedLogger.log(`Debug logs enabled for "${id}"`);
        }
        catch (e) {
            exportedLogger = fakeLogger;
        }
    }
    else {
        exportedLogger = fakeLogger;
    }
}
export const logger = exportedLogger;
